"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _withStyles = _interopRequireDefault(require("../withStyles"));

var _Typography = _interopRequireDefault(require("../Typography"));

var _Card = _interopRequireDefault(require("../Card"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj.default = obj;
    return newObj;
  }
}

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

var FeedSection =
/*#__PURE__*/
function (_Component) {
  _inherits(FeedSection, _Component);

  function FeedSection(props) {
    var _this;

    _classCallCheck(this, FeedSection);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(FeedSection).call(this, props));
    _this.state = {
      isLoading: !!(props.section.fetch && !props.section.cards),
      filters: props.section.filters || {
        limit: 10,
        offset: 0
      },
      cards: props.section.cards || []
    };
    return _this;
  }

  _createClass(FeedSection, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.props.section.fetch) {
        this.fetchCards(this.state.filters);
      }
    }
  }, {
    key: "fetchCards",
    value: function fetchCards(filters) {
      var _this2 = this;

      var fetch = this.props.section.fetch;

      if (fetch) {
        this.setState({
          isLoading: true
        });
        fetch(filters).then(function (_ref) {
          var cards = _ref.cards;

          _this2.setState({
            cards: _this2.state.cards.concat(cards),
            isLoading: false
          });
        }).catch(function () {
          _this2.setState({
            isLoading: false
          });
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$state = this.state,
          isLoading = _this$state.isLoading,
          cards = _this$state.cards;
      var _this$props = this.props,
          classes = _this$props.classes,
          className = _this$props.className,
          title = _this$props.section.title;
      return _react.default.createElement("div", {
        className: (0, _classnames.default)(classes.root, className)
      }, _react.default.createElement(_Typography.default, {
        type: "heading3",
        gutterBottom: true
      }, title, isLoading ? " (loading...)" : null), _react.default.createElement("div", {
        className: classes.cards
      }, cards.map(function (card, idx) {
        return _react.default.createElement(_Card.default, _extends({}, card, {
          className: classes.card,
          key: idx
        }));
      })));
    }
  }]);

  return FeedSection;
}(_react.Component);

var styles = function styles() {
  return {
    root: {
      display: "flex",
      flexDirection: "column",
      width: "100%",
      marginBottom: "16px"
    },
    cards: {
      display: "flex",
      flexWrap: "wrap"
    },
    card: {
      margin: "0 6px 6px 0"
    }
  };
};

var _default = (0, _withStyles.default)(styles)(FeedSection);

exports.default = _default;